module.exports = __webpack_public_path__ + "static/media/waypoint_b.7a6fc9de.svg";